class Signal {
  constructor(payload = null) {
    this.signal = this.constructor.name;
    this.payload = payload;
  }
}

class InitStorageSignal extends Signal {}
class StorageReadySignal extends Signal {}
class WorkerErrorSignal extends Signal {}
class StorageQuerySignal extends Signal {}
class StorageCommandSignal extends Signal {}
class StorageResultSignal extends Signal {}

class ScopeSwitched extends Signal {}
class TaskAdded extends Signal {}
class TaskStatusUpdated extends Signal {}
class TaskUpdated extends Signal {}
class TaskCancelled extends Signal {}
class TaskCompleted extends Signal {}
class ExportDataFromDB extends Signal {}
class ImportDataToDB extends Signal {}
class DataExported extends Signal {}
class DataImported extends Signal {}

const mapOptimised = (signal) => {
  const signalMap = {
    [InitStorageSignal.name]: 'InitStorageSignal',
    [StorageReadySignal.name]: 'StorageReadySignal',
    [WorkerErrorSignal.name]: 'WorkerErrorSignal',
    [StorageQuerySignal.name]: 'StorageQuerySignal',
    [StorageCommandSignal.name]: 'StorageCommandSignal',
    [StorageResultSignal.name]: 'StorageResultSignal',
    [ScopeSwitched.name]: 'ScopeSwitched',
    [TaskAdded.name]: 'TaskAdded',
    [TaskStatusUpdated.name]: 'TaskStatusUpdated',
    [TaskUpdated.name]: 'TaskUpdated',
    [TaskCancelled.name]: 'TaskCancelled',
    [TaskCompleted.name]: 'TaskCompleted',
    [ExportDataFromDB.name]: 'ExportDataFromDB',
    [ImportDataToDB.name]: 'ImportDataToDB',
    [DataExported.name]: 'DataExported',
    // [DataImported.name]: 'DataImported'
  }

  return signalMap[signal] || signal
}

export default mapOptimised

export {
  InitStorageSignal,
  StorageReadySignal,
  WorkerErrorSignal,
  StorageQuerySignal,
  StorageCommandSignal,
  StorageResultSignal,
  ScopeSwitched,
  TaskAdded,
  TaskStatusUpdated,
  TaskUpdated,
  TaskCancelled,
  TaskCompleted,
  ExportDataFromDB,
  ImportDataToDB,
  DataExported,
  DataImported
}
